import { createSelector } from 'reselect';

import { getPznOfferList } from 'src/universal/redux/pznData';
import {
  capitalizeButtonText,
  formatLTOOfferButtonText,
  formatSpecialOfferButtonText
} from 'src/universal/utils/formatOfferButton';

export const getOfferContent = createSelector(
  [getPznOfferList, (_, shortName) => shortName],
  (pznOfferList, shortName) => {
    const offer = (pznOfferList || []).find(o => o.shortName === shortName);
    return {
      offerHeader: offer?.header,
      offerDescription: offer?.description,
      dualOfferHeader: offer?.content?.[0]?.header,
      dualOfferDescription: offer?.content?.[0]?.description
    };
  }
);

export const getLtoEnabledOfferBadgeText = createSelector(
  [getPznOfferList, (_, shortName) => shortName],
  (offerList, shortName) => {
    const cardoffer = offerList.find(offer => offer.shortName === shortName) || {};
    const offerButtonText = cardoffer?.offerButton;
    const offerDates = cardoffer?.offerDataDate || {};
    return capitalizeButtonText(
      formatSpecialOfferButtonText(
        formatLTOOfferButtonText(offerDates, offerButtonText)
      )
    );
  }
);

export const getOfferBadgeText = createSelector(
  [getPznOfferList, (_, shortName) => shortName],
  (offerList, shortName) => {
    const cardoffer = offerList.find(offer => offer.shortName === shortName) || {};
    const offerButtonText = cardoffer?.offerButton;
    return offerButtonText;
  }
);
